import React from 'react';
import { Container, Page, GridRow } from './shared/styled/Assembly';

const AppError = () => (
  <Page>
    <GridRow>
      <Container>
        <h1 className="text24--emphasis text-center">
          Oops, an error occurred.
        </h1>
        <p className="text-center">
          You might be offline. Please refresh the page and try again.
        </p>
      </Container>
    </GridRow>
  </Page>
);

export default AppError;
